module.exports = __webpack_public_path__ + "static/img/yc-bj.3cd5b03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yc-bj.png
// module id = xgx0
// module chunks = 26